import React, { useState, useEffect } from 'react';
import { ASSETS } from '../assetManifest.js';

const OrientationLock: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isLandscape, setIsLandscape] = useState(window.matchMedia("(orientation: landscape)").matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: landscape)");

    const handleOrientationChange = (e: MediaQueryListEvent) => {
      setIsLandscape(e.matches);
    };

    // Use the new addEventListener method for modern browsers
    mediaQuery.addEventListener('change', handleOrientationChange);

    // Initial check
    setIsLandscape(mediaQuery.matches);

    return () => {
      mediaQuery.removeEventListener('change', handleOrientationChange);
    };
  }, []);

  if (!isLandscape) {
    return (
      <div className="orientation-lock-overlay">
        <img src={ASSETS.ui.rotateDevice.path} alt="Rotate Device" className="orientation-lock-icon" />
        <p className="orientation-lock-text">Please rotate your device to landscape mode to play.</p>
      </div>
    );
  }

  return <>{children}</>;
};

export default OrientationLock;
